import { render, staticRenderFns } from "./StatusButtons.vue?vue&type=template&id=462074e6"
import script from "./status-buttons.ts?vue&type=script&lang=ts&external"
export * from "./status-buttons.ts?vue&type=script&lang=ts&external"
import style0 from "./status-buttons.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports